export const DEFAULT_DEPTH = 2
export const MIN_DEPTH = 1
export const MAX_DEPTH = 4
export const ALL_EDGE_GROUPS = ["talks", "scripture", "apparatus", "cfm", "foundational"]

const GRAPH_PARAM_KEYS = ["depth", "edges", "center"]

function parseDepth(raw) {
  if (!raw) return DEFAULT_DEPTH

  const value = Number.parseInt(raw, 10)
  if (!Number.isFinite(value)) return DEFAULT_DEPTH

  return Math.min(MAX_DEPTH, Math.max(MIN_DEPTH, value))
}

function parseEdgeGroups(raw) {
  if (!raw) return [...ALL_EDGE_GROUPS]

  const groups = raw
    .split(",")
    .map((entry) => entry.trim())
    .filter((entry) => ALL_EDGE_GROUPS.includes(entry))

  return groups.length > 0 ? [...groups].sort() : [...ALL_EDGE_GROUPS]
}

function edgeGroupsEqual(left, right) {
  if (left.length !== right.length) return false

  return left.every((group, index) => group === right[index])
}

export function parseGraphUrlState(searchParams, defaultCenterShorthand) {
  const depth = parseDepth(searchParams.get("depth"))
  const edgeGroups = parseEdgeGroups(searchParams.get("edges"))
  const centerParam = searchParams.get("center")
  const centerShorthand =
    centerParam && centerParam.length > 0 ? centerParam : defaultCenterShorthand

  return {
    depth,
    edgeGroups,
    centerShorthand,
    defaultCenterShorthand,
  }
}

export function serializeGraphUrlState({ depth, edgeGroups, centerShorthand, defaultCenterShorthand }) {
  const params = new URLSearchParams()

  if (depth !== DEFAULT_DEPTH) {
    params.set("depth", String(depth))
  }

  const sortedGroups = [...edgeGroups].sort()
  if (!edgeGroupsEqual(sortedGroups, [...ALL_EDGE_GROUPS].sort())) {
    params.set("edges", sortedGroups.join(","))
  }

  if (centerShorthand && centerShorthand !== defaultCenterShorthand) {
    params.set("center", centerShorthand)
  }

  return params
}

export function syncGraphUrlState(state) {
  const url = new URL(window.location.href)

  GRAPH_PARAM_KEYS.forEach((key) => url.searchParams.delete(key))

  const serialized = serializeGraphUrlState(state)
  serialized.forEach((value, key) => url.searchParams.set(key, value))

  window.history.replaceState(null, "", url)
}
